import React, { useEffect } from "react";
import { GoogleAdSense } from "next-google-adsense";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;
import "../styles/globals.css";
import "../styles/favourite.css";
import "../styles/form.css";
import "../styles/header.css";
import "../styles/playerview.css";
import "../styles/scrolltotop.css";
import "../styles/sidebar.css";
import "../styles/stream.css";
import "../styles/humburger.css";
import "../styles/currentdate.css";
import "../styles/footer.css";
import "../styles/countrydata.css";
import "../styles/mediaplayer.css";
import "../styles/pagination.css";
import Layout from "../utils/Layout";
import PageTransitionLoader from "../utils/PageTransitionLoader";

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const noop = () => {};

      const consoleProxy = new Proxy(console, {
        get: (target, prop) => {
          if (typeof target[prop] === "function") {
            return noop;
          }
          return target[prop];
        },
      });

      window.console = consoleProxy;
      window.onerror = () => true;
      window.onunhandledrejection = () => true;

      window.addEventListener("error", (e) => {
        e.preventDefault();
      });

      window.addEventListener("unhandledrejection", (e) => {
        e.preventDefault();
      });

      const suppressExtensionError = (message) => {
        return (
          typeof message === "string" &&
          message.includes("Unchecked runtime.lastError")
        );
      };

      window.onerror = (message) => {
        return suppressExtensionError(message) ? true : noop();
      };

      window.onunhandledrejection = (event) => {
        const msg = event?.reason?.message || event?.reason;
        return suppressExtensionError(msg) ? true : noop();
      };
    }
  }, []);

  return (
    <Layout>
      <GoogleAdSense publisherId="pub-9235878225917616" />
      <Component {...pageProps} />
      <PageTransitionLoader />
    </Layout>
  );
}

export default MyApp;
